
import React from 'react';

interface WeekHeaderProps {
	weekDays: Date[];
	formatDayLabel: (date: Date) => { dayName: string; dayNumber: string };
}

export const WeekHeader = ({ weekDays, formatDayLabel }: WeekHeaderProps) => {
	return (
		<div className="grid sticky top-0 z-20 bg-white/80 dark:bg-black/60 backdrop-blur-md border-b border-white/20 dark:border-white/10" style={{ 
			gridTemplateColumns: `80px repeat(${weekDays.length}, 1fr)`,
			marginTop: "1rem"
		}}>
			<div className="h-16 border-r border-white/20 dark:border-white/10 flex items-center justify-center">
				<span className="text-sm font-medium text-foreground/70">Time</span>
			</div>
			
			{weekDays.map((day, dayIndex) => {
				const { dayName, dayNumber } = formatDayLabel(day);
				return (
					<div 
						key={dayIndex} 
						className="h-16 border-r border-white/20 dark:border-white/10 flex flex-col items-center justify-center"
					>
						<span className="font-medium text-foreground">{dayName}</span>
						<span className="text-sm text-foreground/70">{dayNumber}</span>
					</div>
				);
			})}
		</div>
	);
};
